import script from "./CreateHealthGoals.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateHealthGoals.vue?vue&type=script&setup=true&lang=ts"

import "./CreateHealthGoals.vue?vue&type=style&index=0&id=d171c100&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d171c100"]])

export default __exports__